import { Field } from "formik";
import styled from "styled-components/macro";

const Control = styled(Field)`
  background: transparent;
  padding: 16px 12px;
  border-radius: 4px;
  width: 100%;
  border: none;
  outline: none;
  appearance: none;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const ErrorMsg = styled.span(() => ({
  color: "red",
}));

export const ControlContent = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.color.neutral["04"]};
  border-radius: 4px;
  display: block;
  margin-top: 8px;
`;

export const ControlContainer = styled.div(() => ({
  width: "100%",
  [`label + ${ErrorMsg}`]: {
    position: "relative",
    top: "-12px",
  },
}));

export default Control;
